/**
 * Pie de la consola: marca a la izquierda, contacto y copyright a la derecha.
 */

import styles from './Footer.module.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brand}>
          <span className={styles.brandMark}>SC</span>
          <span className={styles.brandName}>SCOPESI</span>
        </div>

        <div className={styles.meta}>
          <span className={styles.label}>Contacto</span>
          <a className={styles.link} href="mailto:info@scopesi.com.ar">
            info@scopesi.com.ar
          </a>
        </div>

        <p className={styles.text}>© {currentYear} Consola SSO — Login unificado</p>
      </div>
    </footer>
  );
}
